export const previewGlobal: string = `
  div[data-case-detail-table] table,
  div[class*="caseDetailTable"] table {
    border-collapse: collapse !important;
    width: 100% !important;
  }

  div[data-case-detail-table] table td,
  div[class*="caseDetailTable"] table td {
    width: 50% !important;
    text-align: center !important;
  }

  div[data-case-detail-table] table td,
  div[data-case-detail-table] table,
  div[class*="caseDetailTable"] table td,
  div[class*="caseDetailTable"] table {
    border: 1px solid transparent !important;
  }
`

export default previewGlobal
